import VideoPlayer from './video-player'

const components = [
  VideoPlayer
]

export default Vue => {
  function register(compMap) {
    compMap.forEach((c, name) => {
      name = c.name || name
      Vue.component(name, c)
    })
  }
  register(components)
}
